module.exports = __webpack_public_path__ + "images/marketing_site/iphone_app/beta_header.jpeg";